"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownArrowIcon = exports.DropdownArrowIconElement = exports.DropdownStyleName = void 0;
var tslib_1 = require("tslib");
var ArrowTriangleDownIcon_1 = require("@tableau/icons/ArrowTriangleDownIcon");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Colors_1 = require("../../styles/Colors");
var Icons_1 = require("../Icons");
exports.DropdownStyleName = TypeStyle.style({
    color: Colors_1.IconFillColors.Rest,
    $nest: {
        '&.onDarkBackground': { color: Colors_1.InvertIconFillColors.Rest },
        '&.onDarkBackground.active': { color: Colors_1.InvertIconFillColors.Hover },
        '&.onDarkBackground.hover': { color: Colors_1.InvertIconFillColors.Hover },
        '&.onDarkBackground.disabled': { color: Colors_1.InvertIconFillColors.Disabled },
        '&.disabled': { color: Colors_1.IconFillColors.Disabled },
        '&.active': { color: Colors_1.IconFillColors.Hover },
        '&.hover': { color: Colors_1.IconFillColors.Hover },
    }
});
var DropdownArrowIconElement = function (props) {
    var active = props.active, disabled = props.disabled, hover = props.hover, onDarkBackground = props.onDarkBackground, style = props.style;
    return React.createElement(ArrowTriangleDownIcon_1.ArrowTriangleDownIcon, { "aria-hidden": true, className: TypeStyle.classes(exports.DropdownStyleName, { active: active, disabled: disabled, hover: hover, onDarkBackground: onDarkBackground }), size: 18, style: tslib_1.__assign(tslib_1.__assign({}, Icons_1.IconStyle), style) });
};
exports.DropdownArrowIconElement = DropdownArrowIconElement;
exports.DropdownArrowIcon = {
    height: 18,
    width: 18,
    icon: exports.DropdownArrowIconElement,
};
//# sourceMappingURL=DropdownArrow.js.map